import tw from 'twin.macro';

const Text = tw.p`text-lg my-8 md:(text-xl)`;

export default Text;
